import i18n from "./i18n";

//Default locales is "en", we can load default translation or create own using this structure models https://apexcharts.com/docs/localization/
import pl from "apexcharts/dist/locales/pl.json";
import en from "apexcharts/dist/locales/en.json";
import { filterCapitalize } from "@/filters/capitalize";

// Set initial configuration
const apex = (window.Apex = {
  _chartInstances: [],
  chart: {
    locales: [pl, en],
    defaultLocale: i18n.locale || "en",
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    decimalsInFloat: 2,
    tooltip: {
      enabled: false,
    },
  },
  yaxis: {
    decimalsInFloat: 2,
  },
  noData: {
    text: filterCapitalize(i18n.t("noData")),
  },
  colors: [
    "#534d69",
    "#00caa8",
    "#a93777",
    "#3498db",
    "#2ecc71",
    "#f1c40f",
    "#f39c12",
    "#bdc3c7",
    "#16a085",
    "#DFFF00",
    "#6495ED",
    "#CCCCFF",
    "#DE3163",
  ],

  /**
   * Sets user locale
   * @param locale as string
   */
  setLocale: (locale: string) => setLocale(locale),
});

function setLocale(locale: string) {
  apex.chart.defaultLocale = locale;
}

export default apex;
export { apex };
